import React from 'react';
import { useTranslation } from 'react-i18next';
import './Footer.css';

function Footer() {
  const { t } = useTranslation();
  return (
    <footer className="site-footer">
      <div className="footer-social-links">
        <a href="https://www.instagram.com/calicorone/" target="_blank" rel="noopener noreferrer">
          <img src="/icons/instagram.svg" alt="Instagram" className="footer-icon" />
          <span>Instagram</span>
        </a>
        <a href="https://velog.io/@calico/posts" target="_blank" rel="noopener noreferrer">
          <img
            src="/icons/blog.svg"
            alt="Blog"
            className="footer-icon"
            style={{
              width: '20px',
              height: '15px',
            }}
          />
          <span>Blog</span>
        </a>
        <a href="https://github.com/calicorone" target="_blank" rel="noopener noreferrer">
          <img
            src="/icons/git-icon.svg"
            alt="Blog"
            className="footer-icon"
            style={{
              width: '20px',
              height: '20px',
            }}
          />
          <span>Git</span>
        </a>
        <a href="https://kr.linkedin.com/in/ahhyun-kim-a58284376" target="_blank" rel="noopener noreferrer">
          <img src="/icons/linkedin.svg" alt="LinkedIn" className="footer-icon" style={{ width: '20px', height: '20px' }} />
          <span>LinkedIn</span>
        </a>
        <a href="mailto:calico@koiro.me">
          <img src="/icons/email.svg" alt="Email" className="footer-icon" />
          <span>Contact</span>
        </a>
      </div>
      <p className="footer-copy">{t('footer.copy', { year: new Date().getFullYear() })}</p>
    </footer>
  );
}

export default Footer;
